module.exports = __webpack_public_path__ + "static/media/blank.1c32d785.pdf";